import React, { useEffect, useState } from "react";
import { useDispatch } from "react-redux";
import {
  Alert as MuiAlert,
  Button,
  DialogActions,
  Box,
  CircularProgress,
  Grid,
} from "@mui/material";
import AddIcon from "@mui/icons-material/Add";
import * as Yup from "yup";
import { spacing } from "@mui/system";
import styled from "@emotion/styled";
import { useForm, FormProvider } from "react-hook-form";
import { yupResolver } from "@hookform/resolvers/yup";

import { useDialog } from "../../../../contexts/DialogContext";
import usePlan from "../../../../hooks/usePlan";
import SearchableAutoComplete from "../../../../components/SearchableAutoComplete";
import usePlanGroup from "../../../../hooks/usePlanGroup";
import { showSuccessSnackbar, showErrorSnackbar } from "../../../../redux/slices/snackbar";
import CustomTextField from "../../../../components/CustomTextField";
import CustomCheckBox from "../../../../components/CustomCheckBox";
import { useTranslation } from "react-i18next";

const Alert = styled(MuiAlert)(spacing);

const MapPlanModal = ({
  planGroupId,
  isNew,
  isSharingAllowed,
  planGroupPlanId,
  isEditable = false,
  actionName = "Add",
  serviceType,
  multiple,
  sharingType,
  sharing,
  allowedPlans,
  setParentValue,
}) => {
  const initialValues = {
    plans: multiple ? [] : null,
    msoSharing: sharing[0],
    distSharing: sharing[1],
    lcoSharing: sharing[2],
    ottMsoSharing: sharing[3],
    ottDistSharing: sharing[4],
    ottLcoSharing: sharing[5],
    isSharingAllowed: isSharingAllowed,
  };

  const validationSchema = Yup.object().shape({
    plans: multiple
      ? Yup.array()
          .of(
            Yup.object().shape({
              label: Yup.string().required(),
              value: Yup.number().required(),
            }),
          )
          .min(1, "You need at least one plan")
      : Yup.object()
          .shape({
            label: Yup.string().required(),
            value: Yup.number().required(),
          })
          .required("Please select the plan"),
    msoSharing: Yup.number().when("isSharingAllowed", {
      is: true,
      then: () =>
        Yup.number()
          .typeError("MSO sharing must be a number")
          .min(0, "Minimum value should be 0")
          .max(100, "Maximum value should be 100")
          .required(),
    }),
    distSharing: Yup.number().when("isSharingAllowed", {
      is: true,
      then: () =>
        Yup.number()
          .typeError("Dist sharing must be a number")
          .min(0, "Minimum value should be 0")
          .max(100, "Maximum value should be 100")
          .required(),
    }),
    lcoSharing: Yup.number().when("isSharingAllowed", {
      is: true,
      then: () =>
        Yup.number()
          .typeError("LCO sharing must be a number")
          .min(0, "Minimum value should be 0")
          .max(100, "Maximum value should be 100")
          .required(),
    }),

    ottMsoSharing: Yup.number().when(["isSharingAllowed", "serviceType"], {
      is: (isSharingAllowed, serviceType) => isSharingAllowed && serviceType === "INTERNET_OTT",
      then: () =>
        Yup.number()
          .typeError("MSO sharing must be a number")
          .min(0, "Minimum value should be 0")
          .max(100, "Maximum value should be 100")
          .required("OTT MSO Sharing is required"),
    }),
    ottDistSharing: Yup.number().when(["isSharingAllowed", "serviceType"], {
      is: (isSharingAllowed, serviceType) => isSharingAllowed && serviceType === "INTERNET_OTT",
      then: () =>
        Yup.number()
          .typeError("Dist sharing must be a number")
          .min(0, "Minimum value should be 0")
          .max(100, "Maximum value should be 100")
          .required("OTT Distributor Sharing is required"),
    }),
    ottLcoSharing: Yup.number().when(["isSharingAllowed", "serviceType"], {
      is: (isSharingAllowed, serviceType) => isSharingAllowed && serviceType === "INTERNET_OTT",
      then: () =>
        Yup.number()
          .typeError("LCO sharing must be a number")
          .min(0, "Minimum value should be 0")
          .max(100, "Maximum value should be 100")
          .required("OTT LCO Sharing is required"),
    }),
  });
  const { unSetDialog } = useDialog();

  const dispatch = useDispatch();

  const { t } = useTranslation();

  const methods = useForm({
    defaultValues: initialValues,
    resolver: yupResolver(validationSchema),
  });

  const [planServiceType, setPlanServiceType] = useState("");

  const { autoSearchPlan, planAutoSearchResults, autoSearchLoading, getPlan, plan } = usePlan();
  const { addPlanGroupPlan, isSubmitting, getPlanGroupPlans, getPlanGroupPlan, planGroupPlan } =
    usePlanGroup();
  const currentPayload = {
    filters: [],
    pagination: {
      pageNumber: 1,
      pageSize: 100,
    },
    sortFields: [],
  };

  const [payload, setPayload] = useState(currentPayload);
  const [modalNew, setModalNew] = useState(isNew);
  const [planGroupPlanPayload, setPlanGroupPlanPayload] = useState({
    filters: [
      {
        fieldName: "planGroupId",
        fieldValue: planGroupId,
        op: "eq",
        isJoin: true,
        dataType: "long",
      },
    ],
    pagination: {
      pageNumber: 1,
      pageSize: 100,
    },
    sortFields: [],
  });

  const [planOptions, setPlanOptions] = useState([]);

  const fetchData = async () => {
    await autoSearchPlan(payload);
  };

  const fetchPlanData = async () => {
    console.log(selectedPlans, "oooooooooooo");
    if (selectedPlans) await getPlan(selectedPlans?.value);
  };

  const fetchPlanGroupPlan = async () => {
    await getPlanGroupPlan(planGroupPlanId);
  };

  useEffect(() => {
    if (planAutoSearchResults.data.length !== 0) {
      setPlanOptions([...planOptions, ...planAutoSearchResults.data]);
    }
  }, [planAutoSearchResults]);

  useEffect(() => {
    fetchData();
  }, [payload]);

  useEffect(() => {
    if (planGroupPlanId != undefined) {
      fetchPlanGroupPlan();
    }
  }, []);

  useEffect(() => {
    console.log(isEditable, planGroupPlan, initialValues, "planGroupPlanllsoff");
    if (planGroupPlan != undefined && Object.keys(planGroupPlan).length != 0 && isEditable) {
      initialValues["plans"] = [
        { label: planGroupPlan.plan?.planName, value: planGroupPlan.plan?.planId },
      ];
      initialValues["planGroupPlanId"] = planGroupPlan?.planGroupPlanId;
      initialValues["msoSharing"] = planGroupPlan.msoSharing;
      initialValues["distSharing"] = planGroupPlan.distSharing;
      initialValues["lcoSharing"] = planGroupPlan.lcoSharing;
      initialValues["isSharingAllowed"] = planGroupPlan.isSharingAllowed;
      reset(initialValues);
    } else {
      reset(initialValues);
    }
  }, [planGroupPlan]);

  const {
    handleSubmit,
    control,
    reset,
    watch,
    formState: { errors },
    setValue,
  } = methods;

  console.log(errors, "my errrrs");

  const onSubmit = async (data) => {
    try {
      const plans = data.plans;
      const totalSharing = data.msoSharing + data.distSharing + data.lcoSharing;
      console.log(totalSharing, isSharingAllowed, "totalSharing");
      if (totalSharing != 100 && isSharingAllowed) {
        dispatch(showErrorSnackbar("Sharing should be equal to 100"));
        return;
      }
      const totalOttSharing = data.ottMsoSharing + data.ottDistSharing + data.ottLcoSharing;
      if (planServiceType == "INTERNET_OTT" && totalOttSharing != 100 && isSharingAllowed) {
        dispatch(showErrorSnackbar("OTT sharing should be equal to 100"));
        return;
      }
      let newPlans = [];
      console.log(data, "data.......");
      if (Array.isArray(plans)) {
        console.log(plans, "plans,....");
        for (let i = 0; i < plans.length; i++) {
          const planDetails = await getPlan(plans[i]["value"]);
          const currentPlanServiceType = planDetails?.serviceType;

          newPlans.push({
            planId: plans[i]["value"],
            planName: plans[i]["label"],
            msoSharing: data.msoSharing,
            distSharing: data.distSharing,
            lcoSharing: data.lcoSharing,
            ottMsoSharing:
              currentPlanServiceType == "INTERNET"
                ? 0
                : data.ottMsoSharing
                  ? data.ottMsoSharing
                  : 0,
            ottDistSharing:
              currentPlanServiceType == "INTERNET"
                ? 0
                : data.ottDistSharing
                  ? data.ottDistSharing
                  : 0,
            ottLcoSharing:
              currentPlanServiceType == "INTERNET"
                ? 0
                : data.ottLcoSharing
                  ? data.ottLcoSharing
                  : 0,
            serviceType: serviceType,
            isSharingAllowed: isSharingAllowed,
            sharingType: sharingType,
          });
        }
      } else {
        newPlans.push({
          planId: plans["value"],
          planName: plans["label"],
          msoSharing: data.msoSharing,
          distSharing: data.distSharing,
          lcoSharing: data.lcoSharing,
          ottMsoSharing: data.ottMsoSharing ? data.ottMsoSharing : 0,
          ottDistSharing: data.ottDistSharing ? data.ottDistSharing : 0,
          ottLcoSharing: data.ottLcoSharing ? data.ottLcoSharing : 0,
          serviceType: planServiceType,
          isSharingAllowed: isSharingAllowed,
          sharingType: sharingType,
        });
      }
      console.log(allowedPlans, newPlans, "allowedPlans");
      setParentValue("allowedPlans", [...allowedPlans, ...newPlans]);
      dispatch(showSuccessSnackbar("Plan mapped successfully!"));
      unSetDialog("map_plan_modal");
    } catch (err) {
      console.log(err, "errerrerr");
      dispatch(showErrorSnackbar(err.message));
    }
  };

  const selectedPlans = watch("plans");
  useEffect(() => {
    if (selectedPlans != null && !Array.isArray(selectedPlans)) {
      fetchPlanData();
    }
  }, [selectedPlans]);

  useEffect(() => {
    if (Object.keys(plan).length != 0) {
      setPlanServiceType(plan.serviceType);
      if (plan.serviceType == "INTERNET") {
        setValue("ottMsoSharing", 0);
        setValue("ottDistSharing", 0);
        setValue("ottLcoSharing", 0);
      }
    }
  }, [plan]);

  return (
    <React.Fragment>
      <FormProvider {...methods}>
        <form onSubmit={handleSubmit(onSubmit)}>
          <Box sx={{ borderBottom: 1, borderColor: "divider", marginTop: 10 }}>
            <Grid container spacing={12} className="row" pt={8}>
              <Grid item xs={10} sm={12} md={4} lg={4} xl={4}>
                <SearchableAutoComplete
                  control={control}
                  data={planOptions}
                  label={t("plan_name")}
                  payload={payload}
                  setPayload={setPayload}
                  loading={autoSearchLoading}
                  name="plans"
                  multiple={multiple}
                  hasNextPage={planAutoSearchResults.paging.hasNextPage}
                  disabled={isEditable}
                  fields={validationSchema.fields}
                />
              </Grid>
            </Grid>
            <Grid container spacing={12} className="row" pt={8}>
              {isSharingAllowed && sharingType != "FIXED" && (
                <Grid item md={3}>
                  <CustomTextField
                    label={t("mso_sharing")}
                    name="msoSharing"
                    type="text"
                    my={2}
                    control={control}
                    fullWidth
                    variant="outlined"
                    errors={errors}
                    fields={validationSchema.fields}
                    disabled={sharingType == "FIXED"}
                  />
                </Grid>
              )}
              {isSharingAllowed && sharingType != "FIXED" && (
                <Grid item md={3}>
                  <CustomTextField
                    label={t("dist_sharing")}
                    name="distSharing"
                    type="text"
                    my={2}
                    control={control}
                    fullWidth
                    variant="outlined"
                    errors={errors}
                    fields={validationSchema.fields}
                    disabled={sharingType == "FIXED"}
                  />
                </Grid>
              )}
              {isSharingAllowed && sharingType != "FIXED" && (
                <Grid item md={3}>
                  <CustomTextField
                    label={t("lco_sharing")}
                    name="lcoSharing"
                    type="text"
                    my={2}
                    control={control}
                    fullWidth
                    variant="outlined"
                    errors={errors}
                    fields={validationSchema.fields}
                    disabled={sharingType == "FIXED"}
                  />
                </Grid>
              )}
            </Grid>
            {serviceType == "INTERNET_OTT" && planServiceType == "INTERNET_OTT" && (
              <Grid container spacing={12} className="row" pt={8} id="ott_sharing">
                {isSharingAllowed && sharingType != "FIXED" && (
                  <Grid item md={3}>
                    <CustomTextField
                      label={t("ottMsoSharing")}
                      name="ottMsoSharing"
                      type="text"
                      my={2}
                      control={control}
                      fullWidth
                      variant="outlined"
                      errors={errors}
                      fields={validationSchema.fields}
                      disabled={sharingType == "FIXED"}
                    />
                  </Grid>
                )}
                {isSharingAllowed && sharingType != "FIXED" && (
                  <Grid item md={3}>
                    <CustomTextField
                      label={t("ottDistSharing")}
                      name="ottDistSharing"
                      type="text"
                      my={2}
                      control={control}
                      fullWidth
                      variant="outlined"
                      errors={errors}
                      fields={validationSchema.fields}
                      disabled={sharingType == "FIXED"}
                    />
                  </Grid>
                )}
                {isSharingAllowed && sharingType != "FIXED" && (
                  <Grid item md={3}>
                    <CustomTextField
                      label={t("ottLcoSharing")}
                      name="ottLcoSharing"
                      type="text"
                      my={2}
                      control={control}
                      fullWidth
                      variant="outlined"
                      errors={errors}
                      fields={validationSchema.fields}
                      disabled={sharingType == "FIXED"}
                    />
                  </Grid>
                )}
              </Grid>
            )}
          </Box>
          <DialogActions>
            <Button
              disabled={isSubmitting}
              type="submit"
              variant="contained"
              color="primary"
              startIcon={<AddIcon />}
              endIcon={isSubmitting ? <CircularProgress size={24} /> : null}
            >
              {actionName}
            </Button>

            <Button variant="text" onClick={() => unSetDialog("map_plan_modal")} color="primary">
              Close
            </Button>
          </DialogActions>
        </form>
      </FormProvider>
    </React.Fragment>
  );
};
export default MapPlanModal;
